const apiUrl = 'https://api.jbpc28yy.com/';

export default apiUrl;
